import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthProvider';
import EmploymentJobForm from './EmploymentJobForm';
import { saveEmploymentJob } from '../services/EmploymentJobService';
import './FlexibleEmployment.scss';

function resolveCreatorId(userInfo, user) {
  return userInfo?.id || userInfo?.userId || userInfo?.employeeId || user?.username || '';
}

export default function CreateEmploymentJobPage() {
  const authContext = useAuth();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState({ type: '', text: '' });

  const companyId = authContext.additionalUserInfo?.companyId;

  const handleSubmit = async (job) => {
    if (!companyId) {
      setStatus({ type: 'error', text: 'Your company details are missing. Please complete your profile first.' });
      return;
    }

    setSaving(true);
    setStatus({ type: '', text: '' });

    try {
      await saveEmploymentJob(authContext.token, {
        ...job,
        companyId,
        creatorId: resolveCreatorId(authContext.additionalUserInfo, authContext.user),
        creationDate: job.creationDate || new Date().toISOString(),
      });

      setStatus({ type: 'success', text: 'Job advertised successfully.' });
      navigate('/flexible-employment/jobs');
    } catch (error) {
      console.error('Failed to save employment job:', error);
      setStatus({ type: 'error', text: 'Unable to save this job right now. Please try again.' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex-employment-page">
      <div className="flex-employment-shell">
        <div className="flex-employment-hero">
          <div>
            <h1>Create flexible employment ad</h1>
            <p>Advertise temporary staff requirements for cafes, events, or other short-term resourcing needs.</p>
          </div>
        </div>

        {status.text && status.type === 'error' && <div className="flex-employment-error">{status.text}</div>}
        {status.text && status.type === 'success' && <div className="flex-employment-success">{status.text}</div>}

        <EmploymentJobForm submitLabel="Publish job" submitting={saving} onSubmit={handleSubmit} />
      </div>
    </div>
  );
}